import { groupBy } from 'lodash-es';
import {
  SERVER_HISTORIES_ACTIONS,
  SERVER_STATUSES_GROUPS,
  TASK_STATE_TEXTS,
  SERVER_HISTORIES_STATUSES
} from '@/common/constants/servers.constants';
import { ServerEvent } from '@schema';

export default {
  getServersGroupedByNode: (_, getters) => groupBy(getters.getItems, 'hostName'),
  getItemPendingState: state => (id, target) => state.pendingItems[`${id}.${target}`] || false,
  getServerHistories: state => (id) => (state.serverHistories[id] || []).map(historyItem => ({
    ...historyItem,
    actionText: SERVER_HISTORIES_ACTIONS[historyItem.action] || historyItem.action
  })) || [],
  getRunningActionState: state => (id) => state.runningActions[id] || false,
  taskStates: () => TASK_STATE_TEXTS,
  statusesGroup: () => SERVER_STATUSES_GROUPS,
  getServerEvents: state => (id) => state.serverEvents[id].map(event => ({
    ...event,
    statusIcon: SERVER_HISTORIES_STATUSES[event.status] || event.status,
    subevents: event.subevents.map(subevent => ({
      ...subevent,
      statusIcon: SERVER_HISTORIES_STATUSES[subevent.result] || subevent.result,
      isError: subevent.result === ServerEvent.status.ERROR
    })),
  })) || []
};
